import { type FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage'; // localStorage

import { billingApi } from './api';
import claimScrubberReducer from './slice';

/**
 * Billing feature module definition
 * Includes claim scrubber UI state management
 */
export const billingFeature: FeatureModule = {
  // Basic feature identification
  id: 'billing',
  name: 'Billing',

  // No dependencies for this feature
  dependencies: [],

  // Feature reducers
  reducers: {
    claimScrubber: claimScrubberReducer,
  },

  // API middleware is registered separately via billingApi
  middleware: [],

  // Persistence configuration for UI preferences
  persistence: {
    enabled: true,
    storage: storage, // Use localStorage for preferences
    whitelist: ['panel.position', 'preferences'], // Only persist position and preferences
    debounce: 1000,
  },

  // Sync configuration for UI state
  sync: {
    enabled: true,
    whitelist: ['panel.isOpen', 'navigation'], // Sync panel state and navigation across tabs
  },

  // Feature lifecycle hooks
  setup: _store => {
    // Feature initialization logic can go here
  },

  cleanup: _store => {
    // Feature cleanup logic can go here
  },
};

/**
 * Initialize billing feature
 */
export function initializeBillingFeature() {
  return {
    api: billingApi,
    feature: billingFeature,
  };
}